export const CARDS_PER_PAGE = 3;
